import { cloneDeep } from 'lodash';
const SET_LOGGED_IN = 'SET_LOGGED_IN';
const SET_LOGGED_OUT = 'SET_LOGGED_OUT';
import { navigate, deleteCookie } from './high_level_actions';
import { closeModal } from './active_modal';
import { detachCustomer } from './customer';
import { destroyPaymentMethods } from './payment_methods';
import { setComputedCart } from './computed_cart';
import { delayedClearFeedback, setFeedback } from './feedback';
import { activeStepCreate } from './active_enroll_step';
import { clearEnrollShippingSuccess} from './enroll_shipping_success';
import { clearEnrollPaymentSuccess } from './enroll_payment_success';
import { clearCreditAcceptState } from './credit_accept_state';
import { clearUpgradeStatus } from './upgrade_status';
import { setCreditViewDefault } from './credit_view';
import request from 'superagent';

const initialState = false;

export default function reducer(state = cloneDeep(initialState), action) {
	switch (action.type) {
		case SET_LOGGED_IN:
			return true;
		case SET_LOGGED_OUT:
			return false;
		default:
			return state;
	}
}

export function setLoggedIn(){
	return { type: SET_LOGGED_IN }
}

export function setLoggedOut(){
	return { type: SET_LOGGED_OUT }
}

export function logoutStore() {
  return (dispatch, getState) => {
  	let oFakeEvent = {
	    preventDefault: () => {/* noop */},
	    currentTarget: {
	      pathname: '/catalog'
	    }
	  };
    deleteCookie('shouldShowCredits');
    document.cookie = "id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    deleteCookie('enrollCart');
    request
      .get('/svc/customer/logout/')
      .end( (err) => console.log(err));

    dispatch([
      closeModal(),
      detachCustomer(),
      setLoggedOut(),
      destroyPaymentMethods(),
      setFeedback( 'You are now logged out.' ),
      activeStepCreate(),
      setComputedCart( {}, getState().computedCart, []),
      delayedClearFeedback(),
      clearEnrollPaymentSuccess(),
      clearEnrollShippingSuccess(),
      clearUpgradeStatus(),
      clearCreditAcceptState(),
      setCreditViewDefault(),
      navigate(oFakeEvent)
    ]);
  }
}


// WEBPACK FOOTER //
// ./src/modules/is_logged_in.js